import * as Contacts from 'expo-contacts';
import i18n from '@/utils/i18n';
import React from 'react';
import { ActionSheet } from './action-sheet';
import { partnerSupplier } from '@/utils/environment';
import { Platform } from 'react-native';
import { useToasts } from '@/contexts/toast-context';

interface Props {
  onClose: () => void;
  onPermissionGranted: () => void;
}

export const ContactsPermissionActionSheet: React.FC<Props> = ({
  onClose,
  onPermissionGranted,
}) => {
  const { showErrorToast } = useToasts();
  return (
    <ActionSheet
      actions={
        Platform.OS === 'ios'
          ? [i18n.t('continue')]
          : [i18n.t('turn_on'), i18n.t('not_now')]
      }
      horizontalButtons
      isVisible
      message={i18n.t('contacts_permission.message')}
      onAction={async (_, index) => {
        if (index === 0) {
          try {
            const { status } = await Contacts.requestPermissionsAsync();
            if (status === Contacts.PermissionStatus.GRANTED) {
              onPermissionGranted();
            }
          } catch (e) {
            showErrorToast();
          }
        }
        onClose();
      }}
      onBackdropPress={
        Platform.OS === 'ios'
          ? () => {
              // prevent closing to appease the app store reviewer
            }
          : undefined
      }
      onClose={onClose}
      title={i18n.t('contacts_permission.title', {
        appName: partnerSupplier.fullName,
      })}
    />
  );
};
